import React, { useEffect, useState } from "react";
import Logo from "../images/difi.avif";
import LogoDark from "../images/difiDark.avif";
import { Typography, IconButton } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import Brightness7Icon from "@mui/icons-material/Brightness7";

const Navbar = ({
  countries,
  toggleSelection,
  selectedCountries,
  theme,
  toggleTheme,
  setTheme,
}) => {
  const [currentTheme, setCurrentTheme] = useState(theme || "dark");
  const logoImg = currentTheme === "dark" ? Logo : LogoDark;

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "dark";
    setCurrentTheme(savedTheme);
    setTheme(savedTheme);
  }, [setTheme]);

  const handleToggleTheme = () => {
    const newTheme = currentTheme === "light" ? "dark" : "light";
    setCurrentTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    toggleTheme(newTheme);
  };

  return (
    <nav
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "10px 20px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor:
          theme === "light"
            ? "rgba(255, 255, 255, 0.8)"
            : "rgba(18, 18, 18, 0.8)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
    >
      <div style={styles.navbarTop}>
        <a href="https://dififorall.design/" style={styles.logoLink}>
          <img src={logoImg} alt="Difi Logo" style={styles.logo} />
        </a>
        <div style={{ display: "flex", alignItems: "center" }}>
          <a
            className={`home-icon`}
            href="#"
            style={{
              textDecoration: "none",

              color: theme === "light" ? "black" : "white",
            }}
          >
            <Typography
              className={`${
                theme === "light" ? "light-theme-title" : "dark-theme-title"
              }`}
              variant="h5"
              style={{ fontWeight: 500, fontSize: "100%" }}
            >
              Gallery
            </Typography>
          </a>
          <a
            className={`home-icon`}
            href="https://dififorall.design/"
            style={{
              textDecoration: "none",

              color: theme === "light" ? "black" : "white",
            }}
          >
            <Typography
              className={`${theme === "light" ? "light-theme" : "dark-theme"}`}
              variant="h5"
              style={{ fontWeight: 500, fontSize: "100%" }}
            >
              Project
            </Typography>
          </a>

          <IconButton onClick={handleToggleTheme} color="inherit">
            {theme === "light" ? (
              <DarkModeIcon style={{ fontWeight: 500, fontSize: "80%" }} />
            ) : (
              <LightModeIcon style={{ fontWeight: 500, fontSize: "80%" }} />
            )}
          </IconButton>
        </div>
      </div>
    </nav>
  );
};

const styles = {
  navbarTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  logoLink: {
    textDecoration: "none",
  },
  logo: {
    height: "70px",
    paddingRight:'15px',
    cursor: "pointer",
  },
};

export default Navbar;
